



























































import Vue from 'vue'
import bus from '../model/bus'

export default Vue.extend({
    name: 'CreatureList',
    data() {
        return {
            bus,
            manager: bus.game.CreatureManager,
            selected: null,
        }
    },
    created() {},
    computed: {},
    methods: {
        show(item) {
            this.selected = item
            this.$bvModal.show('creature-modal')
        },
    },
})
